module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-bw.8f8d6537.png";